const history = {
  component: null,
  push: (path, state) => history.component.push(path, state),
};

export default history;
